import Mousetrap from 'mousetrap'

import isVisible from './isVisible'

export default {
  data () {
    return {
      mousetrap: null
    }
  },

  mixins: [ isVisible ],

  computed: {
    /*
     * Default empty array
     */
    shortcuts () {
      return []
    }
  },

  created () {
    this.mousetrap = new Mousetrap()
  },

  mounted () {
    this.shortcuts.forEach(this.bind)
  },

  beforeDestroy () {
    this.shortcuts.forEach(this.unbind)
  },

  methods: {
    bind ({ combinations, handler, action }) {
      const callback = event => this.isVisible && handler(event)

       action ? this.mousetrap.bind(combinations, callback, action) : this.mousetrap.bind(combinations, callback)
    },

    unbind ({ combinations, action }) {
      action ? this.mousetrap.unbind(combinations, action) : this.mousetrap.unbind(combinations)
    }
  }
}
